export default "__VITE_ASSET__CPlsW6FY__"